import { FALLBACK_LANGUAGE, LANGUAGES, type LanguageCode } from '../locales';

/** Выбор пользователя: конкретный язык или «как в системе». */
export type LanguagePref = LanguageCode | 'system';

export const LANGUAGE_KEY = 'hc_language';

const SUPPORTED: readonly string[] = LANGUAGES.map((l) => l.code);

/** 'en-US', 'EN_gb' → 'en'; неизвестный или пустой код → null. */
export function toSupported(tag: string | null | undefined): LanguageCode | null {
  if (!tag) return null;
  const base = tag.trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED.includes(base) ? (base as LanguageCode) : null;
}

/** Предпочтение из хранилища; всё непонятное считаем «как в системе». */
export function readLanguagePref(storage: Pick<Storage, 'getItem'> | null): LanguagePref {
  try {
    const v = storage?.getItem(LANGUAGE_KEY);
    return toSupported(v) ?? 'system';
  } catch {
    return 'system';
  }
}

/** Язык интерфейса: явный выбор, иначе первый поддерживаемый язык системы, иначе русский. */
export function resolveLanguage(pref: LanguagePref, systemLanguages: readonly string[]): LanguageCode {
  if (pref !== 'system') return pref;
  for (const tag of systemLanguages) {
    const code = toSupported(tag);
    if (code) return code;
  }
  return FALLBACK_LANGUAGE;
}

/**
 * Локаль Intl для дат и чисел по коду языка интерфейса. Запись обязательна для каждого языка
 * (тип Record): новый язык без неё не соберётся. Неизвестный код → локаль запасного языка.
 */
const INTL_LOCALES: Record<LanguageCode, string> = {
  ru: 'ru-RU',
  en: 'en-US',
};

export function intlLocale(code: string | null | undefined): string {
  return INTL_LOCALES[toSupported(code) ?? FALLBACK_LANGUAGE];
}
